import { useParams } from "react-router-dom";
import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import { VehicleDashBoardProvider } from "./components/vehicle-dashboard/VehicleDashboard.provider";
import { VehicleDashboard } from "./components/vehicle-dashboard";

function VehicleDetailsPage() {
    const { licensePlate } = useParams()

    return (
        <ToastProvider>
            <Dashboard>
                <VehicleDashBoardProvider licensePlate={ licensePlate || ''}>
                    <VehicleDashboard/>
                </VehicleDashBoardProvider>
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}

export default VehicleDetailsPage